"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sansSerifBold = void 0;
exports.sansSerifBold = {
  0x21: [.694, 0, .367],
  0x22: [.694, -0.442, .558],
  0x23: [.694, .193, .917],
  0x24: [.75, .056, .55],
  0x25: [.75, .056, 1.029],
  0x26: [.716, .022, .831],
  0x27: [.694, -0.442, .306],
  0x28: [.75, .249, .428],
  0x29: [.75, .25, .428],
  0x2A: [.75, -0.293, .55],
  0x2B: [.617, .116, .856],
  0x2C: [.146, .106, .306],
  0x2D: [.273, -0.186, .367],
  0x2E: [.146, 0, .306],
  0x2F: [.75, .249, .55],
  0x3A: [.458, 0, .306],
  0x3B: [.458, .106, .306],
  0x3D: [.407, -0.094, .856],
  0x3F: [.705, 0, .519],
  0x40: [.704, .011, .733],
  0x5B: [.75, .25, .343],
  0x5D: [.75, .25, .343],
  0x5E: [.694, -0.537, .55],
  0x5F: [-0.023, .11, .55],
  0x7E: [.344, -0.198, .55],
  0x131: [.458, 0, .256],
  0x237: [.458, .205, .286],
  0x300: [.694, -0.537, 0],
  0x301: [.694, -0.537, 0],
  0x302: [.694, -0.537, 0],
  0x303: [.694, -0.548, 0],
  0x304: [.66, -0.56, 0],
  0x306: [.694, -0.552, 0],
  0x307: [.695, -0.596, 0],
  0x308: [.695, -0.595, 0],
  0x30A: [.694, -0.538, 0],
  0x30B: [.694, -0.537, 0],
  0x30C: [.657, -0.5, 0],
  0x2013: [.327, -0.24, .55],
  0x2014: [.327, -0.24, 1.1],
  0x2015: [.327, -0.24, 1.1],
  0x2017: [-0.023, .11, .55],
  0x2018: [.694, -0.443, .306],
  0x2019: [.694, -0.442, .306],
  0x201C: [.694, -0.443, .558],
  0x201D: [.694, -0.442, .558],
  0x2044: [.75, .249, .55],
  0x2206: [.694, 0, .917]
};